import { useContext, useRef, useState } from 'react'
import { Close } from '@styled-icons/evil'
import Button from '../../../common/Button'
import { getRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import Tooltip from '../../../common/tooltip'
import { encrypt } from '../../../../utils/encryption'
import LinkWithStatus from '../../../common/LinkWithStatus'
import NoRecordsFound from '../../../common/NoRecordsFound'
import InputText from '../../../common/InputText'

const UnMappedSubSystem = () => {
  const { vehicle } = useParams()
  const unmappedSubSystemRef = useRef()
  const [state, dispatch] = useContext(NavContext)
  const [showUnmapped, setShowUnmapped] = useState(false)
  const [unmappedSubSystemData, setUnmappedSubSystemData] = useState([])
  const [filteredSubSystemData, setFilteredSubSystemData] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const getUnmappedFunctionalDiagramList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Un Mapped Sub System Data',
        showLoader: true,
      },
      notification: {},
    })
    setShowUnmapped(true)
    let res = await getRequest(
      `/api/sub_system/functional-diagram/list/unmapped/?make=${vehicle}&without_connectors=true`
    )
    if (res.status) {
      setUnmappedSubSystemData(res.data)
      setFilteredSubSystemData(res.data)
      dispatch({
        type: 'loader',
        data: {
          caption: '',
          showLoader: false,
        },
        notification: {},
      })
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res.msg,
        },
      })
    }
  }

  const goToEdit = (id) => {
    if (window.confirm(`Are you sure, you want to add mapping ?`) === true) {
      let enc = encrypt(String(id))
      window.location.href = `/vehicles/${vehicle}/functional-diagram/${enc}`
    }
  }

  const searchSubSystem = (value) => {
    let tempFilteredData = []
    if (value) {
      tempFilteredData = [...unmappedSubSystemData].filter(
        (row) =>
          row.name.toLowerCase().includes(value.toLowerCase()) ||
          row.sub_system_id.toLowerCase().includes(value.toLowerCase())
      )
    } else {
      tempFilteredData = [...unmappedSubSystemData]
    }
    setFilteredSubSystemData(tempFilteredData)
  }

  return (
    <div ref={unmappedSubSystemRef}>
      <Button
        className={`cursor-pointer btn`}
        text={`Add Sub Systems`}
        onClick={() => {
          getUnmappedFunctionalDiagramList()
        }}
      />
      {showUnmapped && (
        <div style={{ position: 'relative' }}>
          <div
            className={
              'bg-tracer-darkest-blue mt-1 text-black px-2 text-black border-gray-500 border rounded'
            }
            style={{
              position: 'absolute',
              zIndex: 100,
              right: 0,
              width: '50vw',
            }}
          >
            <div className="flex items-center justify-end font-bold pt-1 text-white">
              <Close
                size="1.3rem"
                onClick={() => {
                  setShowUnmapped(false)
                }}
                className="cursor-pointer"
              />
            </div>
            <InputText
              name="sub_system"
              placeholder={`Search Sub System`}
              type="search"
              onChange={(e) => {
                searchSubSystem(e)
                setSearchValue()
              }}
              value={searchValue}
            />
            <div
              style={{
                maxHeight: '50vh',
                overflowY: 'scroll',
                position: 'relative',
                minHeight: '20vh',
              }}
            >
              {filteredSubSystemData?.map((sub_system, index) => {
                return (
                  <div
                    key={`unmapped-sub-details-${index}`}
                    className={`flex flex-row flex-wrap items-center w-full py-1 px-2 text-white justify-between border-gray-500 border-t ${unmappedSubSystemData?.length - 1 === index && 'border-b'}`}
                  >
                    <div className="flex w-8/12 items-center table_text text-base">
                      <Tooltip
                        message={`${sub_system.sub_system_id}/${sub_system.name}`}
                      >
                        <div className="font-bold">
                          {sub_system.sub_system_id}
                        </div>
                        <div className="text-xs">{sub_system.name}</div>
                      </Tooltip>
                    </div>
                    <div className="flex w-4/12 items-center table_text justify-end">
                      <LinkWithStatus
                        href={`/vehicles/${vehicle}/functional-diagram/${sub_system.id}`}
                        className={
                          'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-1 px-2 rounded'
                        }
                        title="Add Mapping"
                        onClickFunc={() => {
                          goToEdit(sub_system.id)
                        }}
                      />
                    </div>
                  </div>
                )
              })}
              {filteredSubSystemData?.length < 1 && (
                <NoRecordsFound caption="Sub System not found" />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default UnMappedSubSystem
